import { useUndo } from "../../Utils/undo";
import { EditOffSharp, ErrorSharp } from "@mui/icons-material";
import { useForceUpdate } from "@react-spring/shared";
import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import Fonts from "../middle.screen.parent.component/Fonts";
import Chrome from "react-color";
import Lottie from "lottie-web";
import { default as LottieLoader } from "react-lottie";
import { Tooltip } from "react-tippy";
import InputRange from "react-input-range";
import PopCharFurther from "../leftmenu.component/SUBcomponents/Assets/popCharFurther";
import "react-input-range/lib/css/index.css";
import TTS from "../../TextToSpeech/TTS";
import GetDur from "../../editor.component/bottom.component/timline/getdur";
import axios from "axios";
import AuthContext from "../../context/userAuth.context";
import loader from "../../assets/Loader/AssetLoader.json";
import CharacterEditor from "../../Editor/CharacterEditor";
import gradientMeshIMG from "../../assets/default.svg";
import AnimationPanel from "./AnimationPanel";
import TickerContext from "../../context/ticker";
import VoiceTrimSettings from "./VoiceTrimSettings";

const CharacterSettings = () => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    setTTSData,
    editableObject,
    LayersData,
    setLayersData,
    setChangeCount,
    setCharacterData,
    ChangeCount,
    seteditableObject,
    clone,
    CharacterData,
    isTTS,
    setIsTTS,
    setRedoLayer,
    UndoLayer,
    EditorZoom,
    setUndoLayer,
    setCharacterId,
    setCharacterEditor,
  } = useContext(MyContext);
  const undo = useUndo();
  const { authenticationData, Access } = useContext(AuthContext);
  const { premiumActionsArray } = useContext(TickerContext);
  const [values, setvalues] = useState(editableObject.editableItem);
  const [showColorPicker, setshowColorPicker] = useState(false);
  const [rangeValue, setrangeValue] = useState(values.opacity * 100);
  const [showActions, setshowActions] = useState(false);
  const [showTTSPanel, setshowTTSPanel] = useState(false);
  const [showMainPainel, setshowMainPanel] = useState(true);
  const [showAddTTSPanel, setshowAddTTSPanel] = useState(false);
  const [UploadData, setUploadData] = useState(null);
  const [ttsaudios, setTtsaudios] = useState([]);
  const [MyLoader, setMyLoader] = useState(false);
  const [showAnimationPanel, setshowAnimationPanel] = useState(false);

  const [showColorThemes, setshowColorThemes] = useState(false);
  const [SelectedColorTheme, setSelectedColorTheme] = useState(undefined);
  var ColorPallets = require("./ColorPallets.json");
  const [animationPanelType, setanimationPanelType] = useState("");
  //colors are comma seperated
  //color 1 is for Shirt
  //color 2 is for bottom
  //color 3 is for skin
  //color 4 is for eys
  //color 5 is for hairs and Beard

  useEffect(() => {
    setvalues(editableObject.editableItem);
    setshowColorPicker(false);
    setshowActions(false);
    setshowTTSPanel(false);
    setshowMainPanel(true);
    setshowAnimationPanel(false);
    setshowAddTTSPanel(false);
    setshowColorThemes(false);
    if (editableObject.openAnimation) {
      setshowMainPanel(false);
      setshowAnimationPanel(true);
      setanimationPanelType(editableObject.animationPanelType);
    }
  }, [editableObject]);

  const StackStore = () => {
    console.log('StackStore ---------')
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  //Lock function
  const lockFun = async () => {
    undo("lockFun"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].lock = !array[i].lock;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
    //leftPanelHide
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //delete function
  const deleteFun = () => {
    undo("deleteFun"); // Ctrl+Z goes back to before this change
    // debugger;
    setIsTTS(false);
    var array = Array.from(LayersData);
    let changeArray = array.filter(function (value, index, arr) {
      if (value.key !== values.key) {
        value.Added = true;
        return value;
      } else {
        if (value.type == "Props") {
          Lottie.destroy(value.AnimationId);
        } else if (value.type == "Character") {
          Lottie.destroy(value.AnimationId);
        }
      }
    });
    setLayersData(changeArray);
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Duplicate Element Function
  const Duplicate = (params) => {
    undo("Duplicate"); // Ctrl+Z goes back to before this change
    var typelength = 1;
    var checkKey = 0;
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === values.type) {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
      }
      if (LayersData[i].FurtherSetting === true) {
        LayersData[i].FurtherSetting = false;
      }
    }
    const array2 = JSON.parse(JSON.stringify(values));
    array2.key = checkKey + 1;
    if (array2.type === "text") {
      array2.TextId = values.TextId + "-" + typelength;
    }
    array2.x = array2.x + 10;
    array2.y = array2.y + 10;
    array2.Name = `${values.type}-${typelength}`;
    array2.AnimationId = values.AnimationId + "-" + typelength;
    array2.layerIndex = topIndex;
    array2.toolbar = false;
    array2.Added = true;
    array2.FurtherSetting = false;
    array2.Editable = true;
    setLayersData(LayersData.concat(array2));
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Opacity Function
  const changingOpacity = (value) => {
    undo("changingOpacity"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].opacity = value / 100;
        array[i].originalOpacity = value / 100;
        break;
      }
    }
    setLayersData(array);
    setrangeValue(Math.trunc(value));
  };

  //Flip Horizontly
  const flipHorizontal = async (e) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (array[i].flip === "scaleX(1)") {
          array[i].flip = "scaleX(-1)";
        } else {
          array[i].flip = "scaleX(1)";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };
  //Flip Horizontly
  const flipVertically = async (e) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].rotateAngle = array[i].rotateAngle + 180;
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Alignment to canvas function
  const alignCanvas = async (alignment) => {
    await StackStore();

    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (alignment === "left") {
          array[i].x = 0;
          array[i].orignalX = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "right") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var xpostion =
            editor.clientWidth - (array[i].width * EditorZoom) / 100;
          array[i].x = (xpostion / EditorZoom) * 100;
          array[i].orignalX = xpostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "top") {
          array[i].y = 0;
          array[i].originalY = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "bottom") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            editor.clientHeight - (array[i].height * EditorZoom) / 100;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerV") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientHeight - (array[i].height * EditorZoom) / 100) / 2;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerH") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientWidth - (array[i].width * EditorZoom) / 100) / 2;
          array[i].x = (ypostion / EditorZoom) * 100;
          array[i].orignalX = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        }
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
    //Repeating this to update the dragger
    const array2 = Array.from(LayersData);
    for (let i = 0; i < array2.length; i++) {
      if (array2[i].key === values.key) {
        array2[i].Editable = true;
        array2[i].showDiv = true;
        break;
      }
    }
    setLayersData(array2);
  };

  //color picker functions
  const [Textcolor, setTextcolor] = useState(values.textColor);

  var ClrChangeStart = false;
  const colorChange = (e) => {
    if (ClrChangeStart === false) {
      ClrChangeStart = true;
      // props.setoverlayHide(true)
    }
    setTextcolor(e.rgb);
  };

  const colorChangeComplete = async (e) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].textColor = e.hex;
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
    ClrChangeStart = false;
    // setTimeout(function () { props.setoverlayHide(false) }, 200);
    //console.log("CompleteCall");
  };

  const showActionsPanel = () => {
    //debugger;
    if (values.character_FilePath != "") {
      var poseList = values.character_poses,
        name = values.character_Name,
        FileName = values.character_FilePath,
        miniImg = values.ImageSrc;
      let ChangePose = true;
      let prvKey = values.key;
      if (values.character_FilePath.includes("Male")) {
        let gender = "Male";
        setCharacterData({
          poseList,
          gender,
          name,
          FileName,
          miniImg,
          ChangePose,
          prvKey,
        });
      } else {
        setCharacterData({
          poseList,
          name,
          FileName,
          miniImg,
          ChangePose,
          prvKey,
        });
      }
      setshowActions(true);
      setshowMainPanel(false);
    }
  };

  const getaudios = () => {
    return new Promise(async (resolve, reject) => {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );

      axios
        .get(authenticationData.ApiBaseURL + "/api/Character/GetSounds", {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        })
        .then((response) => {
          response.data.userSounds.map((value) => {
            value.isPlay = true;
            value.Audio = null;
          });

          setTtsaudios(response.data.userSounds);
          resolve();
          // console.log("usr sounds");
          // console.log(response.data.userSounds);
        });
    });
  };

  const ReadyandShowTTSPanel = () => {
    getaudios().then(() => {
      setshowTTSPanel(true);
      setshowMainPanel(false);
    });
  };

  const openCharacterEditorPanel = () => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        setCharacterId(values.AnimationId);
        break;
      }
    }
    setCharacterEditor(true);
    setshowMainPanel(false);
    setshowColorPicker(true);
  };

  const applyColorPallet = (item) => {
    setSelectedColorTheme(item);
  };

  return (
    <div>
      {showMainPainel && (
        <>
          <div className="d-flex topOptions mb-4">
            <div className="settingsTitle bolderFont">Edit Character</div>
            <div className="topRightOptions">
              {/* <button
                onClick={() => {
                  setshowMainPanel(false);
                  setshowAnimationPanel(true);
                }}
                className="btn btn-small btn-Special mr-2"
              >
                Animate
              </button> */}
              <button
                onClick={() => {
                  setshowMainPanel(false);
                  setshowAnimationPanel(true);
                }}
                className="btn btn-small btn-Special mr-2"
              >
                Animate
              </button>
              <Tooltip
                title="Duplicate"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons grey" onClick={Duplicate}>
                  <span className="material-icons">content_copy</span>
                </div>
              </Tooltip>
              <Tooltip
                title="Delete"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons red" onClick={deleteFun}>
                  <span className="material-icons material-icons-outlined">
                    delete
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Lock"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons black" onClick={lockFun}>
                  <span className="material-icons material-icons-outlined">
                    lock
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="CharacterOptionsWrapper">
            <div
              className="Innerpanel mr-2"
              onClick={() => {
                showActionsPanel();
              }}
            >
              <div className="panelItems">
                <span className="material-icons">directions_run</span>
                <div className="panelText ml-2">Actions</div>
              </div>
            </div>
            <div className="Innerpanel" onClick={() => ReadyandShowTTSPanel()}>
              <div className="panelItems">
                <span className="material-icons">record_voice_over</span>
                <div className="panelText ml-2">Add Speech</div>
              </div>
            </div>
          </div>

          {/* Trim the character's voice (only shown when it has one) */}
          <VoiceTrimSettings layerKey={values.key} />

          {values.character_FilePath.includes("Modern") && (
            <div className="colorSettings">
              <div className="settingsTitle">Color</div>
              <Tooltip
                title="Edit Character Colors"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="colorPicker">
                  <div
                    className="colorDisplay gradientMesh"
                    onClick={() => openCharacterEditorPanel()}
                  ></div>
                </div>
              </Tooltip>
            </div>
          )}

          <div className="LabelWithSlider Alignments">
            <div className="settingsTitle mb-2">Transform</div>
            <div className="opacitySlider">
              <Tooltip
                title="Flip X"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div onClick={flipHorizontal} className={"toggleIconSettings"}>
                  <span className="material-icons smallIcon selectIcon">
                    flip
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Flip Y"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div onClick={flipVertically} className={"toggleIconSettings"}>
                  <span
                    className="material-icons smallIcon selectIcon"
                    style={{ transform: "rotate(90deg)" }}
                  >
                    flip
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="LabelWithSlider Alignments">
            <div className="settingsTitle mb-2">Align to Canvas</div>
            <div className="opacitySlider">
              <Tooltip
                title="Align Canvas Left"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("left")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_left
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas Right"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("right")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_right
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas Top"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("top")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_top
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas bottom"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("bottom")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_bottom
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Verticle Center"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("centerV")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_center
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Horizontal Center"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("centerH")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_center
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="LabelWithSlider Transparency">
            <div className="settingsTitle">Transparency</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={100}
                  minValue={0}
                  value={rangeValue}
                  onChange={(value) => changingOpacity(value)}
                />
              </div>
              <div className="opacityValue">{Math.round(rangeValue)}</div>
            </div>
          </div>
        </>
      )}

      {showActions && (
        <>
          <div className="characterActionPanel">
            <div
              className="d-flex"
              style={{ alignItems: "center", marginBottom: "12px" }}
            >
              <div
                className="backtoTextSettings"
                onClick={() => {
                  setshowActions(false);
                  setshowMainPanel(true);
                }}
              >
                <span className="material-icons">chevron_left</span>
              </div>
              <div className="fontDivLabel">Change Character Action</div>
            </div>
            <div className="listScroller mb-4">
              {CharacterData &&
                CharacterData.poseList.map((obj, index) => {
                  return (
                    <div
                      key={index}
                      className="characterGroup"
                      style={{ position: "relative" }}
                    >
                      {Access == "FE" && premiumActionsArray.includes(index) ? (
                        <img
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            width: "20px",
                            height: "20px",
                            zIndex: "1",
                          }}
                          src="../AppIcons/IconsAll/PremiumIcon.svg"
                          alt=""
                        />
                      ) : null}
                      <PopCharFurther
                        fileName={obj.poseFile}
                        data={CharacterData}
                        obj={obj}
                        OpeningfromPanel={true}
                        isPremiumCharacter={premiumActionsArray.includes(index)}
                      />
                      <div className="charpopName">{obj.poseName}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      )}

      {showColorPicker && (
        <div className="characterEditorPanelWrapper">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => {
                setshowColorPicker(false);
                setshowMainPanel(true);
              }}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Modify Character Colors</div>
          </div>

          <div
            className="themesWrapper"
            onClick={() => {
              setshowColorThemes(true);
              setshowColorPicker(false);
            }}
          >
            <div className="themesDescription">
              <label>Themes</label>
              <label className="selectedTheme">Custom</label>
            </div>
            <div className="themesImg">
              <img src={gradientMeshIMG} alt="" width={30} />
            </div>
          </div>

          {SelectedColorTheme !== undefined && SelectedColorTheme !== null ? (
            <CharacterEditor
              SelectedColorTheme={SelectedColorTheme}
            ></CharacterEditor>
          ) : (
            <CharacterEditor></CharacterEditor>
          )}
        </div>
      )}
      {showColorThemes && (
        <div className="characterEditorPanelWrapper">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => {
                setshowColorPicker(true);
                setshowColorThemes(false);
              }}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Back</div>
          </div>
          <div className="">
            {ColorPallets.map((item, index) => {
              var colors = item.colors;
              return (
                <div
                  key={index}
                  className="palletItem"
                  onClick={() => applyColorPallet(item)}
                >
                  <label className="mb-2 ">{item.palletName}</label>
                  <div className="palletColors">
                    <div
                      className="colorItem"
                      style={{ backgroundColor: colors.split(",")[0] }}
                    ></div>
                    <div
                      className="colorItem"
                      style={{ backgroundColor: colors.split(",")[1] }}
                    ></div>
                    <div
                      className="colorItem"
                      style={{ backgroundColor: colors.split(",")[2] }}
                    ></div>
                    <div
                      className="colorItem"
                      style={{ backgroundColor: colors.split(",")[3] }}
                    ></div>
                    <div
                      className="colorItem"
                      style={{ backgroundColor: colors.split(",")[4] }}
                    ></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {showTTSPanel && (
        <div className="TTSpanelWrapper">
          <div className="d-flex topOptions mb-4">
            <div
              className="backtoTextSettings"
              onClick={() => {
                setshowTTSPanel(false);
                setshowMainPanel(true);
              }}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Apply Text to Speech</div>
            <div className="topRightOptions">
              <button
                className="btn btn-small btn-danger"
                onClick={() => {
                  setshowAddTTSPanel(true);
                  setshowTTSPanel(false);
                }}
              >
                Add New Speech
              </button>
            </div>
          </div>

          <div
            className="listScroller scrollbar style-1 mb-4"
            style={{ flexDirection: "column" }}
          >
            {ttsaudios.length > 0 ? (
              ttsaudios.map((value, index) => (
                <GetDur
                  key={"FreeSounds" + index}
                  ttsaudios={ttsaudios}
                  setTtsaudios={setTtsaudios}
                  values={values}
                  value={value}
                  UploadData={UploadData}
                  setUploadData={setUploadData}
                  LayersData={LayersData}
                  setLayersData={setLayersData}
                  authenticationData={authenticationData}
                />
              ))
            ) : (
              <div className="notFound">
                Looks like you have not added any Text to Speech yet. Click Add
                New Speech on top to proceed.
              </div>
            )}
          </div>
        </div>
      )}

      {showAddTTSPanel && (
        <div className="TTSpanelWrapper">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => {
                setshowAddTTSPanel(false);

                ReadyandShowTTSPanel();
              }}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Add New Speech</div>
          </div>

          <TTS></TTS>
        </div>
      )}

      {showAnimationPanel && (
        <AnimationPanel
          setshowMainPanel={setshowMainPanel}
          setshowAnimationPanel={setshowAnimationPanel}
          values={values}
          animationPanelType={animationPanelType}
        />
      )}
    </div>
  );
};
export default CharacterSettings;
